/**
 * WorkspaceHome — thin switch between the config-driven homepage and the
 * original hard-coded layout, gated by CONFIG_DRIVEN_HOMEPAGE_ENABLED (stage
 * flag). When the flag is off the legacy layout renders exactly as before.
 */
import { CONFIG_DRIVEN_HOMEPAGE_ENABLED } from '../../config';
import ConfigDrivenHome from './ConfigDrivenHome';
import LegacyHome from './LegacyHome';

export default function WorkspaceHome() {
  return CONFIG_DRIVEN_HOMEPAGE_ENABLED ? <ConfigDrivenHome /> : <LegacyHome />;
}
